module.exports = __webpack_public_path__ + "media/images/stock_groups/e813-b22c19fb9b72850e7c1eda99d9336506.svg";